
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouteImportProposal as ObiRouteImportProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-import-proposal.js';
 
 
 

 
 export const ObiRouteImportProposal = createComponent({
   react: React,
   tagName: 'obi-route-import-proposal',
   elementClass: ObiRouteImportProposalElement,
   events: {
     
   }
  });
 
 